import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_FOOD_MOOD_RELATIONS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateFoodMoodRelationsDetailsArgs } from '../graphql/transformers'
import { UPDATE_FOOD_MOOD_RELATIONS_DETAILS } from '../redux/action-types'

const useUpdateFoodMoodRelationsDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isRelationsDetailsLoading, relationsDetailsError } = useSelector(
    store => store.foodMoods.foodMood,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_FOOD_MOOD_RELATIONS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateFoodMoodRelationsDetailsArgs(data),
        },
        dispatch,
        UPDATE_FOOD_MOOD_RELATIONS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isRelationsDetailsLoading,
      error: relationsDetailsError,
    },
  ]
}

export default useUpdateFoodMoodRelationsDetailsMutation
